const getters = {
  processing: (state) => state.processing,
};

export default getters;
